import React from "react";
import { useParams } from "react-router-dom";
import { API_KEY_MAP } from "../utils/constants";

export const MapPage = () => {
  const { latitude, longitude } = useParams();

  return (
    <div>
      <iframe
        title="Google Maps Location"
        width="100%"
        height="100%"
        style={{
          border: 0,
          minHeight: "calc(100vh - 80px)",
        }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps/embed/v1/place?key=${API_KEY_MAP}&q=${latitude},${longitude}`}
      ></iframe>
    </div>
  );
};
